import '@angular/localize/init';

export const CUSTOM_FORM_ERRORS = {
    REQUEST_VALIDATION_ERROR: 'requestValidationError'
};

export const CUSTOM_ERROR_MESSAGES = {
    'min': (min: number, suffix: string = '') => $localize`Minimum value is ${min}${suffix}`,
    'max': (max: number, suffix: string = '') => $localize`Maximum value is ${max}${suffix}`,
    'invalidTemperatureCharacters': () => $localize` Only whole degrees (e.g. 5°C).`
};